import { render, staticRenderFns } from "./CompanyTitle.vue?vue&type=template&id=c442aeb2"
import script from "./CompanyTitle.vue?vue&type=script&lang=js"
export * from "./CompanyTitle.vue?vue&type=script&lang=js"
import style0 from "./CompanyTitle.vue?vue&type=style&index=0&id=c442aeb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports